import { createFileRoute } from "@tanstack/react-router";
import { Credits } from "@/features/credits";
import type { CheckoutOffer } from "@/features/credits/use-subscribe";

interface CreditsSearchParams {
  session_id?: string;
  // A trial link: the onboarding emails' free month, or the $1 month.
  offer?: CheckoutOffer;
}

export const Route = createFileRoute("/_authenticated/credits/")({
  component: Credits,
  validateSearch: (search: Record<string, unknown>): CreditsSearchParams => ({
    session_id: search.session_id as string,
    offer:
      search.offer === "welcome" || search.offer === "dollar"
        ? search.offer
        : undefined,
  }),
});
